import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
const AI_SDR_QA_PORTAL_IDS = [913441057, 99535353];
export const getIsUngatedForAiSdr = () => {
  const portalId = PortalIdParser.get();
  return enviro.isQa() && portalId != null && AI_SDR_QA_PORTAL_IDS.includes(portalId);
};